import { Component, ViewModel, ObservableArray, View, DelegatedObservableArrayChangeListenner } from "binder";
import { getAsBoolean } from "../utilities";
import  { TabView } from "./tab-view"
import { TabItemContainerViewModel } from "./tabItemContainer/tabItemContainer-viewModel";

export class TabViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.itemsMap = new WeakMap<ViewModel,TabItemContainerViewModel>();
        this.internalItems = ObservableArray.create<TabItemContainerViewModel>();
        this.items = ObservableArray.create<ViewModel>();
        this.fillwidth = false;
    }
    GetDefaultView(): View <ViewModel> {
        return new TabView();
    }
    public getTypeId(): string {
        return "VM-A9DBA7FD-D31A-45D8-8133-A0A7D9111BF2"
    }

    private itemsMap:WeakMap<ViewModel,TabItemContainerViewModel>;
    private changeListenner : DelegatedObservableArrayChangeListenner;
    private changeHandler(){
        this.internalItems.update(...this.items.map(x=>{
            if(this.itemsMap.has(x)==false){
                let newContainer = new TabItemContainerViewModel(this);
                newContainer.headerViewTemplate = this.headerViewTemplate;
                newContainer.element = x;
                this.itemsMap.set(x,newContainer);
            }
            return this.itemsMap.get(x);
        }));
        if(this.items.indexOf(this.selecteditem)==-1)
            this.selecteditem = null;
    }
    public set items(v: ObservableArray<ViewModel>) { 
        if(this._items!=null){
            this.items.removeChangeListenner(this.changeListenner);
        }
        this._items = v; 
        if(this._items!=null){
            this.changeListenner = new DelegatedObservableArrayChangeListenner(this,arr=>this.changeHandler());
            this._items.addChangeListenner(this.changeListenner);
            this.changeHandler()
        }
    } public get items(): ObservableArray<ViewModel> { return this._items;} private _items: ObservableArray<ViewModel>;
    public set internalItems(v: ObservableArray<TabItemContainerViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<TabItemContainerViewModel> { return this._internalItems;} private _internalItems: ObservableArray<TabItemContainerViewModel>;
    public set selecteditem(v: ViewModel) { 
        this._selecteditem = v; 
        this.items.forEach(x=>this.itemsMap.get(x).isselected=false);
        if(v!=null){
            let container = this.itemsMap.get(v);
            container.isselected = true;
        }
    } public get selecteditem(): ViewModel { return this._selecteditem;} private _selecteditem: ViewModel;
    public set headerViewTemplate(v: Node) { this._headerViewTemplate = v; } public get headerViewTemplate(): Node { return this._headerViewTemplate;} private _headerViewTemplate: Node;
    public set fillwidth(v: boolean) { this._fillwidth = getAsBoolean(v); } public get fillwidth(): boolean { return this._fillwidth;} private _fillwidth: boolean;
    public set listoftabs(v: boolean) { this._listoftabs = getAsBoolean(v); } public get listoftabs(): boolean { return this._listoftabs;} private _listoftabs: boolean;
    
    select(container:TabItemContainerViewModel) {
        this.selecteditem = container.element;
    }
    
}

